import React from 'react';
import Table from '../../common/Table/Table';
import EditButton from '../../common/ActionButton/EditButton';
import DeleteButton from '../../common/ActionButton/DeleteButton';
import WhatsAppButton from '../../common/ActionButton/WhatsAppButton';
import MailButton from '../../common/ActionButton/MailButton';
import SellerButton from '../../common/ActionButton/SellerListButton';

import '../../../style/PageTable.css';


const EnquiryTable = ({ enquiries, onEdit, onDelete, onRowClick }) => {
  const columns = [
    { header: 'Enquiry ID', title: 'Enquiry ID', key: 'enquiryID' },
    { header: 'Date', title: 'Date', key: 'date' },
    { header: 'Buyer Name', title: 'Buyer Name', key: 'buyerName' },
    { header: 'Description', title: 'Description', key: 'description' },
    { header: 'Status', title: 'Status', key: 'status' },
    { header: 'Actions', title: 'Actions', className: 'actions-header' }
  ];

  const renderRow = (enquiry) => (
    <>
      <td>{enquiry.enquiryID}</td>
      <td>{new Date(enquiry.date).toLocaleDateString()}</td>
      <td>{enquiry.buyerName}</td>
      <td>{enquiry.description}</td>
      <td>{enquiry.status}</td>
      <td className="actions-cell">
        <EditButton onClick={() => onEdit(enquiry.id)} />
        <DeleteButton onClick={() => onDelete(enquiry.id)} />
          {enquiry.phoneNumber && (
          <WhatsAppButton 
            className="whatsapp-btn" 
            title="Send WhatsApp message" 
            phone={enquiry.phoneNumber} />
        )}
        {enquiry.emailID && (
          <MailButton 
            className="mail-btn" 
            title="Send Email"
            email={enquiry.emailID} />
        )}
        <SellerButton onClick={() => onRowClick(enquiry.id)} />
      </td>
    </>
  );

  return (
    <Table 
      columns={columns} 
      data={enquiries} 
      renderRow={renderRow} 
      onRowClick={onRowClick} 
    />
  );
};

export default EnquiryTable;

